import React from 'react'
import styles from './EnquiryNextPlan.module.css'

const EnquiryNextPlan = () => {
    return (
        <div>EnquiryNextPlan</div>
    )
}

export default EnquiryNextPlan